import * as React from 'react';
import * as Draft from 'draft-js';

import getToggleStyleFunc from './getToggleStyleFunc';
import getToggleBlockStyleFunc from './getToggleBlockStyleFunc';
import getCurrentInlineStyle from './getCurrentInlineStyle';
import getCurrentEntity from './getCurrentEntity';
import getSelectedBlock from './getSelectedBlock';
import getEntitySelectionState from './getEntitySelectionState';
import findEntity from './findEntity';
import getSelectedText from './getSelectedText';

const EditorUtils = {
  getToggleStyleFunc,
  getToggleBlockStyleFunc,
  getCurrentInlineStyle,
  getCurrentEntity,
  getSelectedBlock,
  getEntitySelectionState,
  findEntity,
  getSelectedText
};

export default EditorUtils;



/** WEBPACK FOOTER **
 ** ./src/EditorUtils.ts
 **/